const getNumberOfInstructorsToShow = (numberOfInstructors?: number, numberofSyllabusItems?: number): number => {
  if (numberOfInstructors === undefined) {
    return 0;
  }

  if (numberofSyllabusItems === undefined || numberofSyllabusItems === 0) {
    return numberOfInstructors > 3 ? 3 : numberOfInstructors;
  }

  if (numberofSyllabusItems >= 6 && numberOfInstructors >= 3) {
    return 3;
  } else if (numberofSyllabusItems >= 5 && numberOfInstructors >= 2) {
    return 2;
  } else {
    return Math.min(1, numberOfInstructors);
  }
};

export default getNumberOfInstructorsToShow;
